var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 38,
    viewBox: "0 0 60 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3385 0.333332C14.919 0.333332 11.3363 3.91505 11.3363 8.33333C11.3363 12.7516 14.919 16.3333 19.3385 16.3333C23.758 16.3333 27.3407 12.7516 27.3407 8.33333C27.3407 3.91505 23.758 0.333332 19.3385 0.333332ZM48.6799 8.33333C48.6799 12.7516 45.0972 16.3333 40.6777 16.3333C36.2582 16.3333 32.6755 12.7516 32.6755 8.33333C32.6755 3.91505 36.2582 0.333332 40.6777 0.333332C45.0972 0.333332 48.6799 3.91505 48.6799 8.33333ZM59.0561 33.8L55.2151 26.0933C53.8622 23.3842 51.0953 21.6708 48.0664 21.6667H37.3968C37.885 22.3015 38.3135 22.9799 38.6772 23.6933L42.5449 31.4267C43.502 33.3736 43.6272 35.6257 42.8917 37.6667H56.6821C57.6066 37.6639 58.4638 37.1827 58.9474 36.395C59.431 35.6073 59.4722 34.6254 59.0561 33.8ZM26.7006 21.6667C29.739 21.6607 32.5187 23.3756 33.8759 26.0933L37.7169 33.8C38.133 34.6254 38.0918 35.6073 37.6082 36.395C37.1246 37.1827 36.2674 37.6639 35.3429 37.6667H3.33414C2.40963 37.6639 1.5525 37.1827 1.06888 36.395C0.585258 35.6073 0.544117 34.6254 0.960149 33.8L4.80121 26.0933C6.15837 23.3756 8.93807 21.6607 11.9765 21.6667H26.7006Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.7ad918a502d1e8c68b946b1202c5292f.svg";
export { ForwardRef as ReactComponent };